import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import TeamCard from '@/components/TeamCard';
import { useLanguage } from '@/contexts/LanguageContext';

import theodoratosImg from '@/assets/people/theodoratosr-correct.jpg';
import seimanidisImg from '@/assets/people/theodoratosr.jpg';
import panagiotopoulosImg from '@/assets/people/seimanidis.jpg';
import asimakisImg from '@/assets/people/panagiotopoulos.jpg';
import sachpazidisImg from '@/assets/people/asimakis.jpg';
import giftopoulosImg from '@/assets/people/sachpazidis.jpg';
import evangellouImg from '@/assets/people/giftopoulos.jpg';
import tsilalisImg from '@/assets/people/tsilalis-correct.jpg';
import mitsikostasImg from '@/assets/people/tsilalis.jpg';

import kouloumpisImg from '@/assets/people/pezoulas.jpg';
import gatsosImg from '@/assets/people/kouloumpis.jpg';
import patrikiosImg from '@/assets/people/gatsos.jpg';
import dremousisImg from '@/assets/people/patrikios.jpg';
import sxoinaImg from '@/assets/people/sxoina.jpg';
import fotiouImg from '@/assets/people/fotiou.jpg';
import michailidisImg from '@/assets/people/michailidis.jpg';

const managementTeam: Array<{ name: string; nameEn: string; role: string; linkedin: string; image: string; objectPosition?: string }> = [
  { 
    name: 'Θάνος Θεοδωράτος', 
    nameEn: 'Thanos Theodoratos',
    role: 'President & C.E.O. - Tesco Group', 
    linkedin: 'https://www.linkedin.com/in/thanostheodoratos/',
    image: theodoratosImg
  },
  { 
    name: 'Σωτήρης Σεϊμανίδης', 
    nameEn: 'Sotiris Seimanidis',
    role: 'Vice President - Tesco Group', 
    linkedin: 'https://www.linkedin.com/in/sotiris-seimanidis-690038295/',
    image: seimanidisImg
  },
  { 
    name: 'Βασίλης Παναγιωτόπουλος', 
    nameEn: 'Vasilis Panayotopoulos',
    role: 'Managing Director - TFT', 
    linkedin: 'https://www.linkedin.com/in/vasilis-panayotopoulos-06209833a/',
    image: panagiotopoulosImg
  },
  { 
    name: 'Γιώργος Ασημάκης', 
    nameEn: 'Georgios Asimakis',
    role: 'Chief Financial Officer - Tesco Group', 
    linkedin: 'https://www.linkedin.com/in/asimakisgeorge/',
    image: asimakisImg
  },
  { 
    name: 'Παναγιώτης Σαχπαζίδης', 
    nameEn: 'Panagiotis Sachpazidis',
    role: 'Director, Engineering & Projects', 
    linkedin: 'https://www.linkedin.com/in/panagiotis-sachpazidis-07828ba0/',
    image: sachpazidisImg
  },
  { 
    name: 'Πέτρος Γυφτόπουλος', 
    nameEn: 'Petros Gyftopoulos',
    role: 'Director, Units & Systems', 
    linkedin: 'https://www.linkedin.com/in/petrosgyftopoulos/',
    image: giftopoulosImg
  },
  { 
    name: 'Κλειώ Ευαγγέλου', 
    nameEn: 'Clio Evagelou',
    role: 'Director, Quality Control Equipment', 
    linkedin: 'https://www.linkedin.com/in/clio-evagelou-a2a39945/',
    image: evangellouImg
  },
  { 
    name: 'Δημήτρης Τσιλαλής', 
    nameEn: 'Dimitris Tsilalis',
    role: 'Director, Liquid Packaging & Customer Service', 
    linkedin: 'https://www.linkedin.com/in/dimitris-tsilalis-6413a71a2/',
    image: tsilalisImg
  },
];

const salesTeam: Array<{ name: string; nameEn: string; role: string; linkedin: string; image: string; objectPosition?: string }> = [
  { 
    name: 'Βάιος Μητσικώστας', 
    nameEn: 'Vaios Mitsikostas',
    role: 'Sales Director', 
    linkedin: 'https://www.linkedin.com/in/vaios-mitsikostas-3154632b/',
    image: mitsikostasImg,
    objectPosition: 'center 10%'
  },
  { 
    name: 'Λουκάς Κουλουμπής', 
    nameEn: 'Loukas Kouloumpis',
    role: 'Sales Engineering Manager', 
    linkedin: 'https://www.linkedin.com/in/loukas-kouloubis-393043a0/',
    image: kouloumpisImg,
    objectPosition: 'center 10%'
  },
  { 
    name: 'Κώστας Γκάτσος', 
    nameEn: 'Kostas Gatsos',
    role: 'Technical Manager', 
    linkedin: 'https://www.linkedin.com/in/kostas-gkatsos-2817308b/',
    image: gatsosImg
  },
  { 
    name: 'Μανώλης Πατρίκιος', 
    nameEn: 'Manolis Patrikios',
    role: 'Sales Engineering Manager', 
    linkedin: 'https://www.linkedin.com/in/emmanuel-patrikios-86205b22/',
    image: patrikiosImg,
    objectPosition: 'center 5%'
  },
  { 
    name: 'Μελέτης Δρεμούσης', 
    nameEn: 'Meletis Dremousis',
    role: 'Sales Engineer', 
    linkedin: 'https://www.linkedin.com/in/meletis-dremousis-946171223/',
    image: dremousisImg,
    objectPosition: 'center 10%'
  },
  { 
    name: 'Δήμος Μιχαηλίδης', 
    nameEn: 'Dimos Michailidis',
    role: 'Sales Engineer', 
    linkedin: '#',
    image: michailidisImg,
    objectPosition: 'center 15%'
  },
  { 
    name: 'Ειρήνη Σχοινά', 
    nameEn: 'Irene Schoina',
    role: 'Sales Executive', 
    linkedin: 'https://www.linkedin.com/in/eirini-schoina/',
    image: sxoinaImg
  },
  { 
    name: 'Δανάη Φωτίου', 
    nameEn: 'Danai Fotiou',
    role: 'Sales Executive', 
    linkedin: 'https://www.linkedin.com/in/danai-fotiou/',
    image: fotiouImg
  },
];

const People = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('Άνθρωποι', 'People')}
        description={t('Γνωρίστε την ομάδα της TFT. Εξειδικευμένοι μηχανικοί και στελέχη στη βιομηχανία τροφίμων.', 'Meet the TFT team. Specialized engineers and professionals in the food industry.')}
        canonical="https://www.tft.gr/company/people"
      />
      <Navigation />

      <main>
        {/* Hero Section */}
        <section className="py-16 bg-gradient-to-b from-primary to-primary/90 text-primary-foreground">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold mb-4">{t('Οι Άνθρωποί μας', 'Our People')}</h1>
            <p className="text-lg max-w-2xl mx-auto opacity-90">
              {t('Η ομάδα μας είναι η δύναμή μας', 'Our team is our strength')}
            </p>
          </div>
        </section>

        {/* Management Team */}
        <section className="py-20 bg-background">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-12 text-center">{t('Ομάδα Διοίκησης', 'Management Team')}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
              {managementTeam.map((member, index) => (
                <TeamCard
                  key={index}
                  name={t(member.name, member.nameEn)}
                  role={member.role}
                  photo={member.image}
                  linkedin={member.linkedin}
                  objectPosition={member.objectPosition}
                />
              ))}
            </div>

            <h2 className="text-3xl font-bold mb-12 text-center">{t('Ομάδα Πωλήσεων', 'Sales Team')}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {salesTeam.map((member, index) => (
                <TeamCard
                  key={index}
                  name={t(member.name, member.nameEn)}
                  role={member.role}
                  photo={member.image}
                  linkedin={member.linkedin}
                  objectPosition={member.objectPosition}
                />
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default People;
